import { useCallback, useState } from 'react';

import CheckboxInput from 'components/form/CheckboxInput.component';
import TextInput from 'components/form/TextInput.component';
import { PayoutReport } from 'components/report/payment/PayoutReport.component';
import useTip from 'hooks/useTip.hook';

import CN from './PayoutPage.module.scss';

const PayoutPage = () => {
  const { val: same, inv: different, tip: toggleSame } = useTip(false);

  const [bgn, setBgn] = useState('2024-01-01T00:00:00.000');
  const [end, setEnd] = useState('2024-05-31T23:59:59.999');

  const handleBgn = useCallback(({ trimmed }) => setBgn(trimmed), []);
  const handleEnd = useCallback(({ trimmed }) => setEnd(trimmed), []);

  const replacedBgn = bgn.replace(/T\d\d:\d\d:\d\d.\d\d\d/, 'T00:00:00.000');
  const replacedEnd = bgn.replace(/T\d\d:\d\d:\d\d.\d\d\d/, 'T23:59:59.999');

  return (
    <div data-bem="PayoutPage" className={CN.component}>
      <div className={CN.horizontal}>
        <div>
          <CheckboxInput onChange={toggleSame} value={same}>
            same day
          </CheckboxInput>
        </div>
        <div className={CN.field}>
          <TextInput name="bgn" onChange={handleBgn} value={bgn} />
        </div>
        {different && (
          <div className={CN.field}>
            <TextInput name="end" onChange={handleEnd} value={end} />
          </div>
        )}
      </div>
      <PayoutReport begin={same ? replacedBgn : bgn} end={same ? replacedEnd : end} />
      <PayoutReport begin={same ? replacedBgn : bgn} end={same ? replacedEnd : end} permission="all" />
      <PayoutReport begin={same ? replacedBgn : bgn} end={same ? replacedEnd : end} permission="own" />
    </div>
  );
};

// noinspection JSUnusedGlobalSymbols
export default PayoutPage;
